import { render, staticRenderFns } from "./RestricoesRegraNegocio.vue?vue&type=template&id=6d6e8694&scoped=true"
import script from "./RestricoesRegraNegocio.vue?vue&type=script&lang=js"
export * from "./RestricoesRegraNegocio.vue?vue&type=script&lang=js"
import style0 from "@/components/regras/regra-modal.css?vue&type=style&index=0&id=6d6e8694&prod&scoped=true&lang=css&external"
import style1 from "@/components/regras/regra-restricoes.css?vue&type=style&index=1&id=6d6e8694&prod&scoped=true&lang=css&external"
import style2 from "./RestricoesRegraNegocio.vue?vue&type=style&index=2&id=6d6e8694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6e8694",
  null
  
)

export default component.exports